import * as angular from 'angular';
import * as Properties from './shared/childupp-properties';
import { Engine, bootstrapEngine, determineEngine } from './shared/engine-dynamic';
import * as Bootstrap from './shared/childupp-bootstrap';
import * as AutoUpdate from './shared/childupp-auto-update';
import childupp from './app/app.module';

function doPolyfillGlobalScope() {
    // Some legacy applications load their own scripts that
    // rely on $ and jQuery variables available on the global
    // scope
    global.jQuery = require('jquery');
    global.$ = require('jquery');
    // FIXME: Remove this line after upp is removed as a
    // global-magical variable
    window.upp = childupp;
    // FIXME: Remove this after the $UPP definition below is removed
    window.$UPP = {}
}

/**
 * Returns a Promise that is resolved after the application config
 * has been loaded into the runtime and application context.
 * @return {Promise<void>}
 */
async function doLoadAppConfig() {
    const [ childuppId ] = await Promise.all([
        Properties.CHILDUPP_ID
    ]);

    // FIXME: Add this to the angular app licecycle
    // once $UPP is removed as a global-magical variable
    window.$UPP = {
        IDCHILDUPP: childuppId,
        PHONEGAP: determineEngine() === Engine.CORDOVA,
        URL_UPPLICATION_REST_SERVICE: process.env['URL_API_CHILDUPP'],
        URL_WEB_SOCKET_CHILDUPP: process.env['URL_WS_API_CHILDUPP'],
        URL_ANALYTICS_REST_SERVICE: process.env['URL_API_ANALYTICS'],
        URL_UPPLICATION_UMETADATA: process.env['URL_API_UMETADATA'],
        GOOGLE_MAPS_KEY: process.env['GOOGLE_MAPS_KEY'],
    };
}


/**
 * Returns a promise that is resolved after the application has been
 * bootstraped.
 * @return {Promise<void>}
 */
async function doBootstrapApp() {
    // Attempt to preload assets but allow them to fail
    try {
        await Bootstrap.preloadChilduppAssets();
    } catch(e) {
        console.warn('Couldn\'t preload assets due to', e);
    }

    try {
        await Bootstrap.loadChilduppCustomContent();
    } catch(e) {
        console.warn('Couldn\'t load custom content due to', e);
    }
    // Load the app dependencies here (after browser context has been
    // modified) so we can rely on the browser context (window.$UPP,
    // window.upp,...) to have been properly initialized.
    // FIXME: This should be changed into an import statement (at the
    // begining of the file) after the app code is refactored.
    require('./app');
    await Bootstrap.bootstrapAngularApp(childupp);
}

/**
 * Starts the app and returns a promise that resolves after the app has
 * fully started.
 */
async function start() {
    try {
        doPolyfillGlobalScope();
    } catch(e) {
        console.warn('doPolyfillGlobalScope step failed due to:', e.message);
        console.error(e);
    }

    try {
        await bootstrapEngine();
    } catch(e) {
        console.warn('Engine.bootstrapEngine step failed due to:', e.message);
        console.error(e);
    }

    try {
        await doLoadAppConfig();
    } catch(e) {
        console.warn('doLoadAppConfig step failed due to:', e.message);
        console.error(e);
    }

    try {
        await AutoUpdate.install();
    } catch(e) {
        console.warn('AutoUpdate step failed due to:', e.message);
        console.error(e);
    }

    try {
        await doBootstrapApp();
    } catch(e) {
        console.warn('doBootstrapApp step failed due to:', e.message);
        console.error(e);
    }
}

require('./styles/main.less');
start();



// WEBPACK FOOTER //
// ./src/main.js